module.exports = __webpack_public_path__ + "static/hr_capabilities_8-0ecc21860927f23d2fb3205dc312e49e.png";